import {useContext} from "react";
import {AppContext} from "~/context/AppProvider";

export default function useUtilities() {
	const { utilities, setUtilities } = useContext(AppContext);
	return {utilities, setUtilities};
}